import { Outlet, useNavigate, useParams } from 'react-router'
import { AppShell } from '@mantine/core'
import React, { lazy } from 'react'
import { useGetLandingPageQuery } from '../redux/query/LandingPagesApi.slice'
import LoadingPageLoader from './../../components/LoadingPageLoader'
import NotFound from '../../../react/core/NotFound'
import { useFavicon } from '@mantine/hooks'

const Header = lazy(() => import('../components/Header'))
const Footer = lazy(() => import('../components/Footer'))
const ErrorLoading = lazy(() => import('../../../react/core/ErrorLoading'))

/**
 * Renders common shell component for landing pages and job postings.
 * @returns {JSX.Element}
 */
export default function Shell () {
  const { landing_page_identifier: landingPageIdentifier } = useParams()
  const navigate = useNavigate()
  const { data: landingPage, error, isError, isLoading } = useGetLandingPageQuery(landingPageIdentifier)
  useFavicon(landingPage?.favicon)

  if (error?.originalStatus === 404) {
    return <NotFound message='This landing page is no longer available' />
  }

  if (isError) {
    return <ErrorLoading />
  }

  if (isLoading) {
    return <LoadingPageLoader />
  }

  return (
    <AppShell
      header={{ height: { base: 60, md: 90 } }}
      footer={{ height: { base: 90 } }}
    >
      <AppShell.Header
        withBorder={false}
        bg={landingPage.header_background_color}
        pt='10px'
        pb='10px'
      >
        <Header
          logo={landingPage.logo}
          logoClick={() => navigate(`/landing/${landingPageIdentifier}`)}
          companyWebsite={landingPage.company_website}
          color={landingPage.header_link_color}
        />
      </AppShell.Header>

      <AppShell.Main
        bg={landingPage.body_background_color}
      >
        <Outlet/>
      </AppShell.Main>

      <AppShell.Footer
        bg={landingPage.footer_background_color}
        c={landingPage.footer_text_color}
        pt='5px'
        pb='5px'
      >
        <Footer
          landingPageIdentifier={landingPageIdentifier}
          socialMedia={landingPage.social_media}
          linkColor={landingPage.footer_link_color}
          buttonColor={landingPage.button_background_color}
        />
      </AppShell.Footer>
    </AppShell>
  )
}
